import { useFormikContext } from "formik";
import React, { FC, useEffect, useState } from "react";
import { DEF_PG_SIZE_SUB_MIN } from '../../../constants/maximum-page-size';
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import columns from '../../../models/ColumnDefinitions/DeviceTimePatternColumns';
import { DeviceTimePattern } from "../../../models/DeviceTimePattern";
import { Lookup } from "../../../models/Lookup";
import LookupTypes from "../../../models/LookupTypes";
import searchColumns from '../../../models/search/DeviceTimePatternSearch';
import SiteSearch from "../../../models/search/SiteSearch";
import { hideColumns } from "../../../models/utilities/columnHelper";
import { getDeviceTimePatterns } from "../../../services/deviceTimePatternService";
import { getSiteNamesWithPagination } from "../../../services/siteService";
import TableTab from "../../tabs/table-tab";
import { appendFilter } from "../../../utilities/filters";
import { ListQuery } from "../../../models/ListQuery";
import { getDayNames } from "../../../utilities/DateUtils";

interface WizardContentFormProps {
    onNext?: (event: any) => void | undefined;
    onBack?: (event: any) => void | undefined;
    selectedDeviceTimePattern: DeviceTimePattern;
    setSelectedDeviceTimePattern: (device: any) => void;
    site?:string;
}

export const WizardContent: FC<WizardContentFormProps> = ({ onBack = undefined, onNext = undefined, setSelectedDeviceTimePattern, selectedDeviceTimePattern, site }) => {
    const { values, setFieldValue } = useFormikContext<any>();
    const { translate } = useLocale();
    const title = translate.byKey(TranslationKeys.selectAnActivePeriod);
    const [lookup, setLookup] = useState<Lookup[]>([]);

    const onRowClicked = (rowData: any) => {
        const newSelectedDeviceTimePattern = {
            ...selectedDeviceTimePattern,
            days: rowData.days,
            id: rowData.id,
            startTime: rowData.startTime,
            endTime: rowData.endTime,
            endDate: rowData.endDate,
            startDate: rowData.startDate,
            site: rowData.site,
            name: rowData.originalName,
            duration: rowData.duration,
        } as DeviceTimePattern
        setSelectedDeviceTimePattern(newSelectedDeviceTimePattern);
        populateData(newSelectedDeviceTimePattern)
    }

    useEffect(() => {
        (async () => {
            setLookup([{
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            },
            {
                name: LookupTypes.days,
                values: getDayNames(translate)
            }]);
        })();
    }, []);

    const handleBack = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>): void => {
        if (onBack) {
            onBack(e);
        }
    };

    const populateData = (item? : DeviceTimePattern) => {
        if (item && onNext) {
            const fakeOnclickEvent = {} as React.MouseEvent<HTMLButtonElement, MouseEvent>
            const eventWithData = { ...fakeOnclickEvent, itemName: item.name, deviceScheduleItem: values };
            onNext(eventWithData);
        }
    }

    const handleNext = (e: any): void => {
         if (onNext && selectedDeviceTimePattern.id) {
            setFieldValue('deviceTimePatternId', selectedDeviceTimePattern.id);
            onNext({ ...e, itemName: selectedDeviceTimePattern.name, deviceScheduleItem: values })
        }
    }

    return <div className="flex flex-col pt-3 pr-3 h-full" style={{ height: "501px" }}>  {/*might potentionally need some rework for styling*/}
        <div className="overflow-y-auto" style={{ height: '87%' }}>
            <TableContextProvider
                useFilter
                usePagination
                useTable
                useSort
                useSearch
                dataMethod={(listParameters?: ListQuery) => getDeviceTimePatterns(translate, { ...listParameters, filters: appendFilter(site, 'Site id', 'site.id', listParameters?.filters ?? []) })}
                tableDescriptor={hideColumns(columns, ['startDate', 'endDate', 'site'])}
                searchDescriptor={searchColumns}
                maxPageSize={DEF_PG_SIZE_SUB_MIN}
                lookup={lookup}
                canExportReport={false}>
                <TableTab
                    title={title}
                    selectRows={false}
                    onRowClicked={onRowClicked}
                    tableId={'deviceTable'}
                    cyName="wizardContent"
                    customHighlightRow={{ fieldName: "id", comparisonValue: values.deviceTimePatternId }}
                />
            </TableContextProvider>
        </div>
        <div className="flex flex-row justify-end absolute bottom-0 right-0 pr-3 pb-3 ">
            <div className="flex flex-row mt-4">
                <button
                    className={`secondary secondary-inverse py-1 px-5 ${onBack ? '' : 'invisible'}`}
                    type="button"
                    onClick={handleBack}>{translate.byKey(TranslationKeys.back)}</button>
            </div>
            <div className="flex flex-row justify-end mt-4 pl-3">
                <button
                    className={`py-1 px-5 secondary  ${!(selectedDeviceTimePattern.id) ? 'secondary-disabled cursor-not-allowed' : 'secondary-enabled'}`}
                    type='button'
                    onClick={handleNext}>{translate.byKey(TranslationKeys.next)}</button>
            </div>
        </div>
    </div>
};


